import Http from "./Http";
import { mapResponse } from "./interceptors/mapResponse";

const moralisApiLink = "https://deep-index.moralis.io/api/v2";

const headers = {
  "x-api-key": import.meta.env.VITE_APP_MORALIS_API_KEY,
};

export class MoralisService {
  constructor() {
    this.instance = Http.createInstance({
      baseURL: `${moralisApiLink}`,
      headers,
    });
    this.instance.interceptors.response.use(mapResponse);
  }

  get() {
    return this.instance.get.apply(this.instance, arguments);
  }
}

export default new MoralisService();
